module.exports = __webpack_public_path__ + "static/media/KI.33a84eb5.svg";